<script>
import RequestListWrapper from '../components/RequestListWrapper';

export default {
    name: 'Queue',
    extends: RequestListWrapper,
    data() {
        return {
            status: 'На рассмотрении'
        };
    },
    watch: {},
    computed: {},
    methods: {},
    mounted() {}
};
</script>
